<template>
  <div class="min-h-screen flex flex-col bg-gray">
    <GlobalHeader />
    <main class="flex-1 bg-background-gray">
      <div class="content-container mx-auto max-w-[1200px] px-2 sm:px-7 py-7">
        <router-view />
      </div>
    </main>
    <GlobalFooter />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import GlobalHeader from "@components/layouts/GlobalHeader.vue";
import GlobalFooter from "@components/layouts/GlobalFooter.vue";
import { useUserStore } from "@/stores/user";

const userStore = useUserStore();

onMounted(async () => {
  await userStore.fetchCurrentUser();
});
</script>

<style scoped></style>
